import axios from '../../utils/axios';

const postHeartbeat = async (sessionId) => {
  try {
    const response = await axios.post('/api/sessions/heartbeat', {
      sessionId,
    });
    return response.data;
  } catch (err) {
    return err.response?.data || { success: false, message: 'Error al enviar heartbeat' };
  }
};

const postCloseSession = async (sessionId) => {
  try {
    const response = await axios.post('/api/sessions/close', {
      sessionId,
    });
    return response.data;
  } catch (err) {
    return err.response?.data || { success: false, message: 'Error al cerrar sesión' };
  }
};

export {
  postHeartbeat,
  postCloseSession,
};
